<template>
    <div class="wrapper" >
        <img class="head-bg" src="@/assets/CloudQuickPrinting/top.png" alt="/">
        <div class="cen-box">
            <div class="tit-1 flex-box">应用场景解决方案</div>
            <videoSwipe :swipeArr="swipeArr1"></videoSwipe>
            <div class="tit-2 flex-box">新一代打印方式 物联网+云打印</div>
            <div class="tit-2-tips">随时随地，想印就印</div>
            <img class="print-bg" src="@/assets/CloudQuickPrinting/print.png" alt="/">
            <div class="print-box">
                <div class="print-item flex-box" v-for="(item, index) in printArr" :key="'printArr' + index">
                    <img class="icon" :src="item.img" :alt="item.tit">
                    <div class="tit">{{ item.tit }}</div>
                    <div class="tips">{{ item.tips }}</div>
                </div>
            </div>
            <div class="tit-1 flex-box">特色功能</div>
            <div class="feature-box">
                <div class="feature-item" v-for="(item, index) in featureArr" :key="'featureArr' + index">
                    <img class="icon" :src="item.img" :alt="item.tit">
                    <div class="feature-r">
                        <div class="tit">{{ item.tit }}</div>
                        <div class="tips">{{ item.tips }}</div>
                    </div>
                </div>
            </div>
            <div class="tit-1 flex-box">推广商案例</div>
            <videoSwipe :swipeArr="swipeArr2" introHeight="max"></videoSwipe>
            <div class="tit-1 flex-box">合作伙伴</div>
            <img class="head-bg" src="@/assets/CloudQuickPrinting/foot.png" alt="/">
        </div>
    </div>
</template>

<script>
import videoSwipe from './videoSwipe.vue';

export default {
    components: {
        videoSwipe
    },
    data() {
        return {
            loop1: true,//是否开启循环播放
            swipeArr1: [
                {
                    img: require("@/assets/CloudQuickPrinting/swipe-1-1.png"),
                    imgText1: "适用人群：图文店主、广告店主",
                    imgText2: "适用场景：图文店、快印店",
                    imgText3: "",
                    mp4: "",
                    isPlay: false,
                    tit: "图文快印解决方案",
                    intro: "支持电脑自助打印、扫码自助打印、远程自助打印，告别排队等候，软件自动计算纸张数量，先支付后打印，防止纸张损耗，并可自动识别WORD、EXCEL、图片等多种文件格式；"
                },
                {
                    img: require("@/assets/CloudQuickPrinting/swipe-1-2.png"),
                    imgText1: "适用人群：店主、共享打印运营商",
                    imgText2: "适用场景：文具店、便利店、社区等",
                    imgText3: "(印量小)",
                    mp4: require("@/assets/CloudQuickPrinting/swipe-1-1.mp4"),
                    isPlay: false,
                    tit: "共享打印解决方案A",
                    intro: "无人自助打印机，借助印点点自助打印系统，将传统打印机升级为自助打印机，投放到小区、便利店、文具店等场所，面向用户提供自助打印、洗相、制作证件照来实现盈利；<br>支持OEM贴牌，DIY自己专属的自助打印品牌；"
                },
                {
                    img: require("@/assets/CloudQuickPrinting/swipe-1-3.png"),
                    imgText1: "适用人群：智慧校园集成商、政务相关人员",
                    imgText2: "适用场景：高校、法院、政务大厅",
                    imgText3: "(印量大)",
                    mp4: require("@/assets/CloudQuickPrinting/swipe-1-2.mp4"),
                    isPlay: false,
                    tit: "共享打印解决方案B",
                    intro: "无人自助打印机，借助印点点嵌入式自助打印软件，将传统复印机升级为自助复印机，投放到高校、法院、政务大厅等场所，面向用户提供自助打印、复印、扫描来实现盈利；<br>支持敏感信息拦截，安全打印；"
                },
            ],
            printArr: [
                {
                    img: require("@/assets/CloudQuickPrinting/print-1.png"),
                    tit: "100000+",
                    tips: "自助打印网点",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/print-2.png"),
                    tit: "3亿+",
                    tips: "服务人次/年",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/print-3.png"),
                    tit: "6亿+",
                    tips: "订单",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/print-4.png"),
                    tit: "800W小时",
                    tips: "帮商户节省",
                },
            ],
            featureArr: [
                {
                    img: require("@/assets/CloudQuickPrinting/feature-1.png"),
                    tit: "PC自助打印",
                    tips: "一站式自助打印：扫码传文件>打印>收款>出纸傻瓜式打印，高效易上手",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/feature-2.png"),
                    tit: "移动自助打印",
                    tips: "QQ/微信扫码打印，稳定、快速，可多人扫码打印，提高效率，增加营收；",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/feature-3.png"),
                    tit: "财务管理系统",
                    tips: "费率自由设定，资金明细清晰，自动记录分析每笔订单，支持微信、支付宝、现金支付；",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/feature-4.png"),
                    tit: "会员卡系统",
                    tips: "店铺自定义充值套餐，助力锁定客源，快速回笼资金;",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/feature-5.png"),
                    tit: "促销活动助力引流增收",
                    tips: "店主可自主设置充值赠送活动补贴，学生到店打印有机会享受免单打印；",
                },
                {
                    img: require("@/assets/CloudQuickPrinting/feature-6.png"),
                    tit: "一键去黑底",
                    tips: "作业打印、照片打印，一键去黑底，秒变清晰！更多特色功能，等你体验……",
                },
            ],
            swipeArr2: [
                {
                    img: require("@/assets/CloudQuickPrinting/swipe-2-1.png"),
                    tit: "某品牌打印机销售",
                    titP1: "推荐：文印店主*20 获得返利：20000+",
                    titP2: "次年续费继续享有返利噢！",
                    intro: "在给图文店主提供打印设备的同时，顺带给店主推荐安装了印点点软件，硬件+软件结合，和店主之间的纽带更加紧密了。个人认为，印点点对图文店主来说是全新的改革，颠覆了传统的打印店模式，既为客户创造了方便，也为店主节省了人工和时间成本。"
                },
                {
                    img: require("@/assets/CloudQuickPrinting/swipe-2-2.png"),
                    tit: "某品牌打印机经销商",
                    titP1: "推荐：共享打印运营商*5  获得返利：10000+60000/月流水",
                    titP2: "扩展版图，持续加机中！",
                    intro: "疫情时代整体经济形势低迷，打印设备出货量也日渐式微，寻找第二增长曲线是每个企业掌舵者的重中之重。起初拿印点点自助打印系统在文具店投放了两台设备试水，没想到一年内在小县城陆续投放了近百台设备，不仅消化了尾货库存，还在共享经济的热潮下吃到了第一批螃蟹。如今副业转正，安利了5位小伙伴一同上岸。"
                },
            ],
        }
    },
    created() {

    },
    mounted() {
 
    },
    methods: {

    },
};
</script>

<style lang="less" scoped>
@import "../../style/mixin.less";

.wrapper {
    width: 100%;
    min-height: 100vh;
    font-size: .convert(14) [ @vw];
    padding-bottom: .convert(20) [ @vw];
    ;

    .head-bg {
        width: 100%;
        height: auto;
    }

    .cen-box {
        padding: 0 .convert(24) [ @vw];

        .tit-1 {
            height: .convert(85) [ @vw];
            box-sizing: border-box;
            padding-top: .convert(25) [ @vw];
            font-size: .convert(16) [ @vw];
            font-weight: 700;
        }

        .tit-2 {
            font-size: .convert(16) [ @vw];
            font-weight: 700;
            height: .convert(35) [ @vw];
            margin-top: .convert(25) [ @vw];
        }

        .tit-2-tips {
            color: #4D90FF;
            line-height: .convert(12) [ @vw];
            font-size: .convert(12) [ @vw];
            text-align: center;
            margin-bottom: .convert(17) [ @vw];
        }


        .print-bg {
            width: 100%;
            height: auto;
        }

        .print-box {
            display: flex;

            .print-item {
                flex-direction: column;
                flex: 1;
                height: .convert(100) [ @vw];

                .icon {
                    width: .convert(47) [ @vw];
                    height: .convert(47) [ @vw];
                }

                .tit {
                    font-weight: 700;
                }

                .tips {
                    font-size: .convert(11) [ @vw];
                    opacity: 0.8;
                }
            }
        }

        .feature-box {
            margin-top: .convert(16) [ @vw];

            .feature-item {
                display: flex;
                margin-bottom: .convert(32) [ @vw];

                .icon {
                    width: .convert(37) [ @vw];
                    height: .convert(37) [ @vw];
                    margin-right: .convert(10) [ @vw];
                }

                .feature-r {
                    font-size: .convert(13) [ @vw];

                    .tit {
                        font-weight: 700;
                        margin-bottom: .convert(9) [ @vw];
                        line-height: .convert(13) [ @vw];
                    }

                    .tips {
                        color: #666666;
                        line-height: .convert(15) [ @vw];
                    }
                }
            }
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/components/H5/CloudQuickPrinting.vue